/**
 * Index page specific JavaScript
 */

(function() {
    'use strict';

    /**
     * ヒーローセクションの下向き矢印アイコンクリック時にスクロール
     */
    function initHeroScrollDown() {
        const heroScrollDown = document.querySelector('.hero-scroll-down');
        if (!heroScrollDown) {
            console.warn('hero-scroll-down element not found');
            return;
        }
        
        console.log('hero-scroll-down element found, setting up click handler');
        
        // 即座にイベントリスナーを設定（Lenisの初期化を待たない）
        heroScrollDown.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            console.log('hero-scroll-down clicked');
            
            const nextSection = document.querySelector('.about-highlights');
            if (!nextSection) {
                console.warn('nextSection (.about-highlights) not found');
                return;
            }
            
            const headerHeight = document.querySelector('header')?.offsetHeight || 0;
            const additionalOffset = 120;
            const targetPosition = nextSection.offsetTop - headerHeight + additionalOffset;
            
            console.log('Scrolling to position:', targetPosition, 'Lenis available:', !!window.lenis);
            
            // Lenisが利用可能な場合はLenisを使用、そうでなければ通常のscrollTo
            if (window.lenis) {
                window.lenis.scrollTo(targetPosition, {
                    duration: 1.2,
                    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
                    offset: 0
                });
            } else {
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
        
        console.log('Click handler attached to hero-scroll-down');
    }

    /**
     * 1200px以下でカードのボタンクリック時にカードのリンクに遷移
     */
    function initAboutCardButtons() {
        const aboutCards = document.querySelectorAll('.about-card');
        const aboutCardLinks = document.querySelectorAll('.about-card__link');
        
        // メディアクエリのチェック
        const mediaQuery = window.matchMedia('(max-width: 1200px)');
        
        function handleCardButtonClick() {
            if (!mediaQuery.matches) {
                return; // 1200px以上では何もしない
            }
            
            aboutCardLinks.forEach((link, index) => {
                const card = aboutCards[index];
                if (!card || !link) return;
                
                const cardHref = card.getAttribute('href');
                if (!cardHref) return;
                
                // ボタンクリック時にカードのリンクに遷移
                link.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    window.location.href = cardHref;
                });
            });
        }
        
        // 初期化
        handleCardButtonClick();
        
        // リサイズ時に再初期化（必要に応じて）
        let resizeTimer;
        mediaQuery.addEventListener('change', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(handleCardButtonClick, 100);
        });
    }

    /**
     * ページ初期化
     */
    function initIndexPage() {
        initHeroScrollDown();
        initAboutCardButtons();
    }

    // DOMContentLoadedで確実に実行
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initIndexPage);
    } else {
        initIndexPage();
    }
})();

